<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-08 17:38:24
 * @LastEditors: SYY 188842798@qq.com
 * @LastEditTime: 2024-06-24 17:03:09
 -->
<template>
  <div class="container">
    <head-nav-bar title="确认预约" :fixed="true" />
    <div class="mt-header-nav">
      <ContactCard v-model="contact" @change="onContactChange" />

      <div class="kong"></div>
      <div class="">
        <cell-box style="padding: 0.3rem 0;" border>
          <cell-item label="预约医院：" :value="info.hospitalName" />
          <cell-item label="科室门类：" :value="info.departmentName" />
          <cell-item label="就诊医生：" :value="info.doctorName" />
          <cell-item label="就诊时间：">
            <span slot="value"
              >{{ info.treatmentDate }} {{ info.workTimeStart }} -
              {{ info.workTimeEnd }}</span
            >
          </cell-item>
          <cell-item label="号源类型：">
            <span slot="value">
              {{ info.docSourceType }} {{ info.doctorName }}
              {{ RegistrationeFee }}
            </span>
          </cell-item>
          <cell-item label="候诊地址：" :value="info.consultingRoom" />
        </cell-box>
        <div class="kong"></div>
        <div
          class="box"
          style="font-size:0.4rem; margin-top:0.5rem;display: flex;"
        >
          <span>
            <van-checkbox v-model="checked">已阅读并同意</van-checkbox>
          </span>
          <a @click="showAgreement">《预约就诊知情同意书》</a>
        </div>

        <van-dialog
          v-model="visible.agreement"
          confirmButtonText="已阅读并同意"
          title="预约就诊知情同意书"
          show-cancel-button
          @confirm="agreementClick"
        >
          <div
            class="box text"
            v-html="hospitalInfo.bookingInformedRemark"
          ></div>
        </van-dialog>

        <div class="box" style="margin-top:1rem">
          <van-button
            tton
            type="info"
            :disabled="!checked"
            block
            @click="onSubmit"
            :loading="submitLoading"
            >提交预约</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  // ContactCard,
  // ContactList,
  Cell,
  CellGroup,
  Button,
  Popup,
  Checkbox,
  Dialog,
  Field
} from "vant";

import { mapState, mapActions } from "vuex";
import { CellBox, CellItem } from "@/components/cell";
import ContactCard from "@/components/ContactCard";
import { cache, postConfirm } from "@/utils/common";
export default {
  name: "Confirm",
  components: {
    CellBox,
    CellItem,
    [Field.name]: Field,
    ContactCard,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    ...mapState({
      order: state => state.order,
      hospitalInfo: state => state.app.hospitalInfo
    })
  },
  data() {
    return {
      // contactId: "",
      submitLoading: false,
      visible: {
        agreement: false
      },
      info: {},
      checked: false,
      contact: {},
      RegistrationeFee: 0,
      user: null,
      isScreenBack: false,
      needForm: true,
      toScreeningForm: true
    };
  },
  created() {
    // 如果没有筛查表就不跳转
    this.$post("GetScreeningForm_InfoAsync", { EpidemicType: 1 }).then(res => {
      if (res.data == null) {
        this.toScreeningForm = false;
      }
    });
    this.contact = cache.get("currentContact");
    this.user = cache.get("user");
    if (!(this.hospitalInfo && this.hospitalInfo.id)) {
      this.getHospitalInfo();
    }
    this.getInfo();
    const query = this.$route.query;
    setTimeout(() => {
      if (query && query.userData && query.userData.diagnosisCardNo) {
        this.isScreenBack = true;
        this.checked = true;
        this.onSubmit(query.userData);
      }
      this.$post("GetScreeningForm_RecordInfo", {
        DiagnoseCardNo: this.contact.diagnosisCardNo
      }).then(res => {
        if (res.data.length > 0) {
          this.needForm = false;
        }
      });
    }, 1000);
  },

  methods: {
    ...mapActions(["getHospitalInfo"]),
    getInfo() {
      const order = this.order;
      this.$post("Booking_Info", {
        DoctorId: order.DoctorId,
        SourceId: order.SourceId,
        SourceType: 1,
        TreatmentDate: order.TreatmentDate,
        WorkTimeStar: order.WorkTimeStar,
        WorkTimeEnd: order.WorkTimeEnd
      })
        .then(res => {
          this.info = res.data;
          this.isChild();
        })
        .catch(e => {
          console.log(e);
        });
    },
    onContactChange() {
      this.isChild();
    },
    showAgreement() {
      this.visible.agreement = true;
    },
    agreementClick() {
      this.checked = true;
    },
    isChild() {
      const birthYear = new Date(
        this.contact.cardholderBirthDate
      ).getFullYear();
      const currentYear = new Date().getFullYear();
      const diff = currentYear - birthYear;
      if (
        this.info.checkingChildAge &&
        Number(this.info.checkingChildAge > 0)
      ) {
        if (diff < this.info.checkingChildAge) {
          this.RegistrationeFee = this.info.childDiagnoseFee;
        } else {
          this.RegistrationeFee = this.info.outpatientRegistrationeFee;
        }
      }
    },
    onSubmit(userData) {
      this.submitLoading = true;
      const _this = this;
      if (!_this.contact.diagnosisCardNo) {
        _this.$notify("请添加就诊人");
        return false;
      }
      if (!_this.checked) {
        _this.$notify("请阅读并同意《预约就诊知情同意书》");
        return false;
      }

      const info = _this.info;
      const json = {
        DoctorId: info.doctorId + "",
        DoctorName: info.doctorName,
        DepartmentId: info.departmentId + "",
        DepartmentName: info.departmentName,
        BookingDate: info.treatmentDate,
        BookingTimeStart: info.workTimeStart,
        BookingTimeEnd: info.workTimeEnd,
        BookingType: 0 + "",
        WaitingAddress: info.consultingRoom,
        DoctorNoSourceType: info.docSourceTypeId + "",
        DoctorNoSourceTypeDesc: info.docSourceType,
        DiagnosisCardNo: _this.contact.diagnosisCardNo,
        SourceId: info.sourceId,
        ConsultingRoomId: info.consultingRoomId + "",
        SchedulingDetailId: info.sourceId + "",
        OutpatientRegistrationeFee: _this.RegistrationeFee + "",
        BookingMethod: info.bookingMethod + "",
        TimePeriodType: _this.order.TimePeriodType + "",
        PatientName: _this.contact.cardholderName,
        PatientContactPhone: _this.contact.cardholderContactPhone,
        PatientIdentityNo: _this.contact.identityDocNo,
        PatientBirthday: _this.contact.cardholderBirthDate,
        PatientContactAddress: _this.contact.cardholderContactAddress,
        PatientSex: _this.contact.cardholderSex + "",
        PayMethod: 1 + ""
      };
      let api = "Booking_Add";
      if (_this.user.bookingPaymentMode == 3) {
        api = "BookingPaymentModeApi";
      }
      // 时间对比
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      var nowDate = year + "-" + month + "-" + day;
      if (
        _this.info.treatmentDate == nowDate &&
        !_this.isScreenBack &&
        _this.needForm &&
        _this.toScreeningForm
      ) {
        _this.$router.push({
          name: "ScreeningForm",
          query: {
            DepartmentId: _this.info.departmentId,
            DepartmentName: _this.info.departmentName,
            contact: _this.contact,
            api: api,
            json: json,
            user: _this.user
          }
        });
        return false;
      }
      console.log(_this.user);
      debugger;
      postConfirm(_this, api, json, userData, _this.user, () => {
        this.submitLoading = false;
      });
      // setTimeout(() => {
      //   this.submitLoading = false;
      // }, 2000);
    }
  }
};
</script>

<style lang="less" scoped>
.text {
  font-size: 0.35rem;
  line-height: 2;
  padding: 0.5rem 0.3rem;
  max-height: 8rem;
  overflow-y: auto;
  color: #555;
}
</style>
